import { ValidateProperty } from '../../../models/utilities/validate-property';

export class OrderGroupUpdate {

    public id : string = '';
    public groupId : number = 0;
    public rowVersion : string = '';

}

export class OrderGroupRequest {
 
    public serviceCenter : string = '';
    @ValidateProperty({ required: true })
    public updates : OrderGroupUpdate[] = [];

}
